import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '3349617945202976'

let initialized = false

function initPixel() {
  if (initialized) return
  initialized = true

  try {
    if (window.fbq) return

    // Set up the fbq queue function
    const n: any = (window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!window._fbq) window._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    // Load the Facebook pixel script safely
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    ;(
      document.head ||
      document.getElementsByTagName('head')[0] ||
      document.documentElement
    ).appendChild(script)

    window.fbq('init', PIXEL_ID)
  } catch (_) {
    // Silently fail — pixel is non-critical
  }
}

export function useMetaPixel() {
  useEffect(() => {
    try {
      initPixel()
      if (window.fbq) {
        window.fbq('track', 'PageView')
      }
    } catch (_) {}
  }, [])
}

export function trackAddToCart() {
  try {
    if (window.fbq) {
      window.fbq('track', 'AddToCart')
    }
  } catch (_) {}
}
